import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { PortalGuard } from '../auth/_guards/portal.guard';
import { TicketsComponent } from './tickets/tickets.component';

@NgModule({
  declarations: [MainComponent],
  imports: [CommonModule, FormsModule, HttpModule, MainRoutingModule],
  providers: [PortalGuard]
})
export class MainModule {}



// WEBPACK FOOTER //
// ./src/app/portalV2/main.module.ts